import React from "react";
import { is10Perfect, isDefined } from "../../utils/utils";
import I18n from 'i18n.js.erb'


const ProductActionMenu = ({
    viewMode,
    product,
    iconUrl,
    saleItem,
    saleChannel,
    isSaleChannel,
    title,
    description,
    handleClick,
    index,
    maxIndex
}) => {

    return (
        <div className={`col-${viewMode === 'shrinked_medium' ? index === maxIndex ? '12' : '6' : '12'} 
            d-flex justify-content-center w-100
            ${viewMode === 'shrinked_medium' ? (index % 2 === 0 ? index === maxIndex ? 'px-2' : 'pl-2 pr-0' : 'pl-0 pr-2') : 'px-2'}
            ${viewMode === 'shrinked_medium' ? (index <= 1 ? 'pt-2' : (index >= (maxIndex % 2 === 1 ? maxIndex - 1 : maxIndex) ? 'pb-2' : 'py-0')) : 'py-0'}
            action${is10Perfect(product.current_grading) ? '-gold' : ''}-menu-item`}
        >
            <div className={`row w-100 py-${viewMode === 'shrinked_medium' ? '1' : '2'} align-items-center 
                ${viewMode === 'shrinked_medium' && (index % 2 === 0 && index < maxIndex) && 'border-right-active'} 
                ${index < (viewMode === 'shrinked_medium' ? (maxIndex % 2 === 1 ? maxIndex - 1 : maxIndex) : maxIndex) ? `border-bottom-${is10Perfect(product.current_grading) ? 'gold-' : ''}active` : ''}`}
                onClick={(e) => {
                    handleClick(saleItem)
                    e.stopPropagation();
                }}
            >
                <div className={`d-flex justify-content-center col-${viewMode === 'shrinked_medium' ? '12' : '3'} p-0`}>
                    {isSaleChannel ?
                        <div className={`d-flex flex-directions-column bg-${(is10Perfect(product.current_grading) ? 'gold-' : '')}aig-gradient p-1px br-50perc shadow`}>
                            <div className={`d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-${['large', 'shrinked_medium'].includes(viewMode) ? viewMode : 'medium'}`}>
                                <img src={iconUrl} className="cursor-pointer opacity-1-imp" alt="" width={`${viewMode === 'large' ? '30px' : viewMode === 'shrinked_medium' ? '15px' : '20px'}`} />
                            </div>
                        </div>
                        :
                        <img src={iconUrl} className="cursor-pointer" alt="" width={`${viewMode === 'large' ? '64' : viewMode === 'shrinked_medium' ? '30' : '40'}px`} />
                    }
                </div>
                <div className={`col-${viewMode === 'shrinked_medium' ? '12' : '9'} d-${viewMode === 'shrinked_medium' ? 'none' : 'block'} px-1`}>
                    <div className={`text-${is10Perfect(product.current_grading) ? 'gold-' : ''}aig-gradient font-size-${viewMode === 'large' ? '12' : '10'}px text-${viewMode === 'shrinked_medium' ? 'center' : 'left'}`}>
                        <b>
                            {
                                !isDefined(saleItem) ?
                                  title
                                :
                                  (
                                    saleItem.state === 'sold' ?
                                      I18n.t('js.indexSaleItems.actionsMenu.saleChannelViewOnTitle').replace(':sale_channel', saleChannel.meta_name.toUpperCase())
                                    :
                                      I18n.t('js.indexSaleItems.actionsMenu.saleChannelCheckOnTitle').replace(':sale_channel', saleChannel.meta_name.toUpperCase())
                                  )
                            }
                        </b>
                    </div>
                    <div className={`font-size-${viewMode === 'large' ? '12' : '10'}px d-${viewMode === 'shrinked_medium' ? 'none' : 'block'} `}>
                        {
                            !isDefined(saleItem) ?
                              description
                            :
                              (
                                saleItem.state === 'sold' ?
                                  ''
                                :
                                  I18n.t('js.indexSaleItems.actionsMenu.saleChannelCheckOnDescription').replace(':sale_channel', saleChannel.meta_name)
                              )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductActionMenu;